module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/BROKEN_STONE_STYLE.3d831606.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/BROKEN_STONE_STYLE.png
// module id = 1142
// module chunks = 16